'use client';

export { default } from './_pages/MyAppsPage';
